import { ArcElement, Chart as ChartJS, Legend, Tooltip } from "chart.js";
import { useEffect, useState } from "react";
import { LIVE_URL } from "../../../../config/config";
import useAuthToken from "../../../../hooks/useAuthToken";
import WomanImage from "../../../assets/female-worker 1.svg";
import ManImage2 from "../../../assets/Frame 78.png";
import WomanImage2 from "../../../assets/Frame 8.png";
import ManImage3 from "../../../assets/man-in-suit-and-tie 1 (traced) 1 2.svg";
import ManImage from "../../../assets/man-in-suit-and-tie.svg";
import styles from "../css/Member.module.scss";
import ManChart from "./ManChart";
import NewMemberChart from "./NewMemberChart";
import WomenChart from "./WomenChart";
ChartJS.register(ArcElement, Tooltip, Legend);

const Member = () => {
  const { token, loading } = useAuthToken();

  // State to store the fetched dashboard data
  const [dashboardData, setDashboardData] = useState({
    users: 0,
    active_users: 0,
    languages: 0,
    reports: 0,
    active_users_man_woman: {
      men: 0,
      woman: 0,
    },
    inactive_users_man_woman: {
      men: 0,
      woman: 0,
    },
    total_users_man_woman: {
      men: 0,
      woman: 0,
    },
  });

  // Fetch dashboard data
  useEffect(() => {
    async function fetchDashboardData() {
      try {
        const response = await fetch(`${LIVE_URL}/admin/dashboard/get-counts`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const data = await response.json();
        if (data && data.data) {
          setDashboardData(data.data);
        }
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      }
    }
    if (!loading) {
      fetchDashboardData();
    }
  }, [token, loading]);
  return (
    <>
      <div className={`${styles.member}`}>
        <div className={`${styles.member_section}`}>
          <div className={`${styles.member_box}`}>
            <div className={`${styles.member_header}`}>
              <div className={`${styles.chart_wrapper}`}>
                <NewMemberChart />
              </div>
              <div className={`${styles.member_title}`}>
                <h2>User Base Breakdown</h2>
                <div className={`${styles.persontage_section}`}>
                  <div className={`${styles.man_section}`}>
                    <img src={ManImage} alt="" />
                    <p>{dashboardData.total_users_man_woman.men}</p>
                  </div>
                  <div className={`${styles.women_section}`}>
                    <img src={WomanImage} alt="" />
                    <p style={{ color: "#e186e4" }}>
                      {dashboardData.total_users_man_woman.woman}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`${styles.member_box}`}>
            <div className={`${styles.member_header}`}>
              <div className={`${styles.chart_wrapper}`}>
                <WomenChart />
              </div>
              <div className={`${styles.member_title}`}>
                <h2> Women</h2>
                <div className={`${styles.persontage_section}`}>
                  <div className={`${styles.women_section}`}>
                    <img src={WomanImage2} alt="" />
                    <p>{dashboardData.active_users_man_woman.woman} Active</p>
                  </div>
                  <div className={`${styles.women_section}`}>
                    <img src={WomanImage} alt="" />
                    <p style={{ color: "#e186e4" }}>
                      {dashboardData.inactive_users_man_woman.woman} Inactive
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`${styles.member_box}`}>
            <div className={`${styles.member_header}`}>
              <div className={`${styles.chart_wrapper}`}>
                <ManChart />
              </div>
              <div className={`${styles.member_title}`}>
                <h2> Men</h2>
                <div className={`${styles.persontage_section}`}>
                  <div className={`${styles.man_section}`}>
                    <img src={ManImage2} alt="" />
                    <p>{dashboardData.active_users_man_woman.men} Active</p>
                  </div>
                  <div className={`${styles.man_section}`}>
                    <img src={ManImage3} alt="" />
                    <p style={{ color: "#e186e4" }}>
                      {dashboardData.inactive_users_man_woman.men} Inactive
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Member;
